import React from 'react';
import { useEffect, useState } from "react";
import { useStoreState, useStoreActions } from "easy-peasy";
import { types } from "../lib/store";
import {useTranslation} from "react-i18next";
import {types as SimulationTypes} from "./Simulation";
import _ from "lodash";


const SpectrumDetail = ({ spectrum, t }) => {
  return (
    <form className="form-horizontal">
      <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">SWL dB(A)</label>
        <div className="col-sm-6">
          <input type="text" value={ spectrum.power.TOTAL } disabled className="form-control"/>
        </div>
      </div>
      <div className="form-group form-group-sm">
        <label className="col-sm-6 control-label">SPL dB(A)</label>
        <div className="col-sm-6">
          <input type="text" value={ spectrum.pressure.TOTAL } disabled className="form-control"/>
        </div>
      </div>
    </form>
  )
};

function AcousticPoint() {
  const { t } = useTranslation();
  const { availableTypes, spectra, type, distance, minDistance, minDistanceMessageError, directionality } = useStoreState(state => state.selection.acousticData);
  const hasSoundData = useStoreState(state => state.selection[types.HAS_SOUND_DATA]);

  const fan = useStoreState(state => state.selection.fan);
  const designPoint = useStoreState(state => state.selection.designPoint);
  const simulationType = useStoreState(state => state.selection.customizations.simulationType);
  const units = useStoreState(state => state.selection.units);
  const directionalityOptions = useStoreState(state => state.selection.soundDirectionalityOptions)

  const updateStoreConfig = useStoreActions(actions => actions.selection[types.SET_ACOUSTIC_CONFIG]);

  const [config, setConfig] = useState({ type: type, distance: distance, directionality: directionality });
  const [distanceError, setDistanceError] = useState(false);

  const updateLocalState = (e) => {
    setConfig({
      ...config,
      [e.target.name]: e.target.value
    });
  };

  const onChangeDistance = (e) => {
    updateLocalState(e);
    setDistanceError(e.target.value < minDistance);
  }

  const updateStore = (e) => {
    e.preventDefault();

    if(distanceError) {
      return
    }

    updateStoreConfig(config);
  };

  const getTabName = (spectrum) => {
    if (simulationType === SimulationTypes.FREQUENCY && designPoint.frequency !== fan.frequency) {
      return _.trim(`${spectrum.name} ${spectrum.frequency} Hz`);
    } else {
      return spectrum.name;
    }
  };

  useEffect(() => {
    setConfig({ type: type, distance: distance, directionality: directionality });
    setDistanceError(distance < minDistance);
  }, [spectra, availableTypes, type, distance, directionality, setDistanceError]);

  const [currentTab, setCurrentTab] = useState(0);

  const toggleTab = (ev) => {
    ev.preventDefault();

    setCurrentTab(parseInt(ev.target.dataset.tabIndex));
  };

  const getName = (name) => {
    if (name === "in")
      return t("frontend:fan.acoustic.inlet");

    if (name === "out")
      return t("frontend:fan.acoustic.outlet");

    if (name === "rad")
      return t("frontend:fan.acoustic.radial");

    return "";
  };

  if (!hasSoundData) {
    return <></>
  }

  return (
    <div className="panel panel-info">
      <div className="panel-heading">
        { t("frontend:fan.acoustic_data") }
      </div>
      <div className="panel-body">
        {
          spectra.length > 1 &&
          <ul className="nav nav-tabs" style={{marginBottom: "15px"}}>
            {spectra.map((spectrum, index) =>
              <li key={`${spectrum.name}-${index}`} className={index === currentTab ? "active" : ""}>
                <a href="#" data-tab-index={index} onClick={toggleTab}>{getTabName(spectrum)}</a>
              </li>
            )}
          </ul>
        }
        <div className="tab-content">
          {spectra.map((spectrum, index) =>
            <div key={`${spectrum.name}-${index}`} className={index === currentTab ? "" : "hidden"}>
              <SpectrumDetail spectrum={spectrum} t={t} />
            </div>
          )}
        </div>
        <form id="acoustic_form" className="form-horizontal" onSubmit={updateStore}>
          <div className="form-group form-group-sm">
            <label className="col-sm-6 control-label">{ t('frontend:fan.acoustic.espectre') }</label>
            <div className="col-sm-6">
              <select name="type" className="form-control" onChange={updateLocalState} value={config.type}>
                {Object.keys(availableTypes).map((type, index) => {
                  return <option key={`${type}-${index}`} value={type}>{ getName(type) }</option>
                })}
              </select>
            </div>
          </div>
          <div className="form-group form-group-sm">
            <label className="col-sm-6 control-label">{ t('frontend:fan.acoustic.directionality_factor') }</label>
            <div className="col-sm-6">
              <select name="directionality" className="form-control" onChange={updateLocalState} value={config.directionality}>
                {directionalityOptions.map((value, index) => {
                  return <option key={`${value}-${index}`} value={value}>{ value }</option>
                })}
              </select>
            </div>
          </div>
          <div className={ distanceError ? "form-group form-group-sm has-error" : "form-group form-group-sm" }>
            <label className="col-sm-6 control-label">{t('frontend:user_preferences.distance')} ({ t(`units:${units.distance}`) })</label>
            <div className="col-sm-6">
              <input name="distance" className="form-control" type="number" step="0.01" min="1" value={config.distance || ''} onChange={onChangeDistance}/>
            </div>
            { distanceError && <div className="col-sm-12 acoustic-help-block">
              <p className="help-block ">{ minDistanceMessageError }</p>
            </div> }
          </div>
          <div className="text-center">
            <button type="submit" className="btn btn-primary">{ t('frontend:send') }</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AcousticPoint;
